import React from 'react';

import information from '../../../images/information_black.svg';

import { FOHImage } from '../../ingredients';

export const FOHInformationBlackIcon = (props: any) => (
  <FOHImage
    source={{ uri: information }}
    style={{
      width: 24,
      height: 24
    }}
    {...props}
  />
);
